import type { AnalyticsInterval } from "@/redux/certifications/types";
import type {
  AnalyticsFilterState,
  FunnelStage,
  PassRateLevel,
  PassRateLevelName,
} from "@/features/certifications/analytics/types";

export const INTERVALS = {
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
} as const satisfies Record<AnalyticsInterval, AnalyticsInterval>;

export const PASS_RATE_LEVEL_NAMES = {
  HEALTHY: "healthy",
  FAIR: "fair",
  LOW: "low",
} as const satisfies Record<string, PassRateLevelName>;

export const FUNNEL_STAGES = {
  ENROLLED: "enrolled",
  WEEK: "week",
  LAST_WEEK: "lastWeek",
} as const satisfies Record<string, FunnelStage>;

export const LOW_PASS_RATE: PassRateLevel = {
  name: PASS_RATE_LEVEL_NAMES.LOW,
  min: 0,
  color: "var(--orange-500)",
};

export const PASS_RATE_LEVELS: PassRateLevel[] = [
  {
    name: PASS_RATE_LEVEL_NAMES.HEALTHY,
    min: 0.8,
    color: "var(--primary-1000)",
  },
  { name: PASS_RATE_LEVEL_NAMES.FAIR, min: 0.7, color: "var(--primary-600)" },
  LOW_PASS_RATE,
];

export const FUNNEL_BAR_MAX_HEIGHT = 150;
export const FUNNEL_BAR_MIN_HEIGHT = 6;

export const ANALYTICS_SKELETON_LINES = 4;

export const LIGHT_TRACK_SLUG = "participation";

export const CARD_SIZES = {
  AUTO: "auto",
  HALF: "half",
  FULL: "full",
} as const;

export const SERIES_COLORS = [
  "var(--primary-600)",
  "var(--orange-700)",
  "var(--green-500)",
  "var(--orange-900)",
] as const;

export const PROGRESSION_RAMP = [
  "var(--primary-400)",
  "var(--primary-500)",
  "var(--primary-600)",
  "var(--primary-800)",
  "var(--primary-1000)",
  "var(--primary-1100)",
] as const;
export const CERTIFIED_COLOR = "var(--green-500)";

export const CHART_HEIGHT = 240;
export const TALL_CHART_HEIGHT = 300;

export const ANALYTICS_INTERVALS: AnalyticsInterval[] = [
  INTERVALS.DAY,
  INTERVALS.WEEK,
  INTERVALS.MONTH,
];
export const PROGRESSION_INTERVALS: AnalyticsInterval[] = [
  INTERVALS.WEEK,
  INTERVALS.MONTH,
];
export const ANALYTICS_DEFAULT_WEEKS = 12;
export const ANALYTICS_MAX_POINTS = 370;

export const DEFAULT_FILTERS: AnalyticsFilterState = {
  track: undefined,
  startDate: undefined,
  endDate: undefined,
  interval: INTERVALS.WEEK,
};

export const BUCKET_LABEL_FORMATS: Record<AnalyticsInterval, string> = {
  DAY: "d MMM",
  WEEK: "d MMM",
  MONTH: "MMM yyyy",
};

export const SECTION_KEYS = {
  OVERVIEW: "overview",
  ACTIVITY: "activity",
  WEEKS: "weeks",
  KNOWLEDGE_CHECKS: "knowledgeChecks",
  COMMUNITY: "community",
  PATHS: "paths",
} as const;
